@if(isLoadingLookup){
<div class="d-flex justify-content-center p-3">
    <mat-spinner diameter="30"></mat-spinner>
</div>
} @else {
<form [formGroup]="form" class="row">
    <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Modelo do documento</mat-label>
            <mat-select formControlName="tiposNota" multiple>
                @for (tipo of listaModeloDocumento; track tipo.idModeloDocumento) {
                <mat-option [value]="tipo.idModeloDocumento">{{ tipo.nome }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Emitente</mat-label>
            <mat-select formControlName="listCnpj" multiple>
                @for (empresa of listaEmpresas; track empresa.idEmpresa) {
                <mat-option [value]="empresa.cnpj">
                    {{ empresa.nomeEmpresa }} | {{empresa.cnpj}}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Pesquisar...</mat-label>
            <input matInput formControlName="pesquisar" placeholder="Nota, Destinatário...">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>

    <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Série</mat-label>
            <input matInput type="text" formControlName="serie" mask="000" [validation]="false" inputmode="numeric" maxlength="3" />
        </mat-form-field>
    </div>

    <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Status</mat-label>
            <mat-select formControlName="isCacnelada">
                <mat-option [value]="null">Todas</mat-option>
                <mat-option [value]="true">Canceladas</mat-option>
                <mat-option [value]="false">Autorizadas</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>CFOP</mat-label>
            <input matInput type="text" formControlName="cfop" [mask]="masks.cfop" [validation]="false" inputmode="numeric" />
                    <button mat-icon-button matSuffix type="button" class="icon-mat-symbols-btn"
                        aria-label="Pesquisar CFOP" [disabled]="form.get('cfop')?.disabled"
                        (click)="$event.stopPropagation(); pesquisarCfop()">
                        <mat-icon>search</mat-icon>
                    </button>
        </mat-form-field>
    </div>
</form>
}
